import styled from 'styled-components'
import { ASSETS } from '../../../constants/assets'
import { setPaddingSize } from '../../../utils/contentfulStyles.utils'
import ImgUtil from '../../../utils/img.utils'

export const ContentRowsContainer = styled.div<{
  $topPadding: string
  $bottomPadding: string
  $backgroundTheme: string
  $useCase?: string
}>`
  ${({ theme, $topPadding, $bottomPadding, $useCase, $backgroundTheme }) => {
    let backgroundStyles = ''

    const titleDark = theme.webMktNewPalette.black
    const titleLight = theme.webMktNewPalette.white
    const bodyDark = theme.webMktNewPalette.white
    const bodyLight = theme.webMktNewPalette.deepBlue[55]
    const lineDark = theme.webMktNewPalette.deepBlue[60]
    const lineLight = theme.webMktNewPalette.deepBlue[35]
    const arrow = $backgroundTheme === 'Dark' ? ASSETS.UP_ARROW_LIGHT_ICON : ASSETS.UP_ARROW_ICON

    if ($useCase === 'Agenda' && (!$backgroundTheme || $backgroundTheme === 'unset')) {
      backgroundStyles = `background-color: unset;`
    } else if ($backgroundTheme === 'Grey') {
      backgroundStyles = `background-color: ${theme.webMktNewPalette.deepBlue[10]};`
    } else if ($backgroundTheme === 'Light') {
      backgroundStyles = `background-color: ${theme.webMktNewPalette.background.light.default};`
    } else if ($backgroundTheme === 'Dark') {
      backgroundStyles = `background-color: ${theme.webMktNewPalette.deepBlue[70]};`
    }

    return `
      ${backgroundStyles}
      padding-top: ${setPaddingSize($topPadding)}px;
      padding-bottom: ${setPaddingSize($bottomPadding)}px;

      && {
          p {
          color: ${$backgroundTheme === 'Dark' ? titleLight : titleDark};
          }
          .Agenda__Item {
          p, h6 {
          color: ${$backgroundTheme === 'Dark' ? titleLight : titleDark};
                }
          }
        .FAQ__Item-Container {
          border-color: ${$backgroundTheme === 'Dark' ? lineDark : lineLight};
          .FAQ-Item__Label {
            color: ${$backgroundTheme === 'Dark' ? titleLight : titleDark};

            &:after {
              background-image: url(${ImgUtil.getResizedImageUrl(arrow, '')});
            }

            &.FAQ-Item__Label:before {
              background-color:  ${$backgroundTheme === 'Dark' ? lineDark : lineLight};
            }

          }
        }

        .FAQ-Item__Item-Body {
          .Inline-CTA-Container {
            width: 100%;
            text-align: center;
            margin: 24px 0;
          }

          color: ${$backgroundTheme === 'Dark' ? bodyDark : bodyLight};

          p {
            color: ${$backgroundTheme === 'Dark' ? bodyDark : bodyLight};
          }

        }
      }
    `
  }}
`

export const AgendaContainer = styled.div`
  margin-bottom: 0px;

  .Agenda__Item {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 16px 0;
    border-top: 1px solid ${({ theme }) => theme.webMktNewPalette.alphaBlack[10]};
    border-bottom: 1px solid ${({ theme }) => theme.webMktNewPalette.alphaBlack[10]};

    .Agenda__Item-Body {
      width: 100%;
      padding-left: 21.5%;
      margin: 16px 0 0 0;
    }

    .Agenda__Item-Label {
      width: 17%;
      margin: 0;
      color: ${({ theme }) => theme.webMktPalette.grayCold[65]};
    }

    .Agenda__Item-Title {
      width: 78.5%;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      flex-direction: column;
      .Agenda__Item-Label,
      .Agenda__Item-Title {
        width: 100%;
      }

      .Agenda__Item-Label {
        margin: 0 0 16px 0;
      }

      .Agenda__Item-Body {
        padding: 0;
      }
    }
  }
`

export const FAQContainer = styled.div`
  .FAQ__Item-Container {
    .FAQ-Item__Accordion-Item {
      display: none;
    }

    cursor: pointer;
    margin-bottom: 0;
    padding: 24px;
    border-bottom: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[35]};

    &:first-of-type {
      border-top: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[35]};
    }

    &:hover {
      background: none;
    }

    .FAQ-Item__Label {
      position: relative;
      padding-right: 141px;

      &:after {
        content: '';
        width: 24px;
        height: 24px;
        background-size: contain;
        top: 0px;
        right: 0;
        position: absolute;
        background-size: contain;
        background-repeat: no-repeat;
        transform: rotate(180deg);
      }

      ${({ theme }) => theme.breakpoints.down('sm')} {
        padding-right: 87px;
      }

      ${({ theme }) => theme.breakpoints.down('xs')} {
        padding-right: 49px;
      }
    }

    &.FAQ-Item__Active {
      .FAQ-Item__Label:after {
        transform: none;
      }

      .FAQ-Item__Label {
        padding-bottom: 24px;
        position: relative;

        &:before {
          content: '';
          position: absolute;
          bottom: 0;
          width: 172px;
          left: -16px;
          height: 1px;
        }
      }

      .FAQ-Item__Accordion-Item {
        margin-top: 24px;
        display: block;
        max-width: 768px;
      }
    }
  }
`
